import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Table from "examples/Tables/Table";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import customerData from "./data/authorsTableData";
import Loading from "components/ApnaLoading";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import apiService from "services/api";

function HelpPage() {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(false);

  const loadHelps = async (onStatusChange) => {
    try {
      setLoading(true);
      const response = await apiService.getHelps();
      const result = response?.data;
      if (!result?.success) {
        throw new Error(result?.message || "Failed to fetch help requests");
      }
      setCounts(result.count || {});
      setTableData(
        customerData({
          data: result?.data,
          onStatusChange,
        })
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      setTableData({ columns: [], rows: [] });
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await apiService.updateHelp(id, { status: newStatus });
      const result = response?.data;
      if (result?.success) {
        toast.success(`Help status updated to ${newStatus}`);
        await loadHelps(handleStatusChange);
      } else {
        toast.error(result?.message || "Failed to update status");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    }
  };

  useEffect(() => {
    loadHelps(handleStatusChange);
  }, []);

  const { columns, rows } = tableData;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={2}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <MiniStatisticsCard
                title={{ text: "Total" }}
                count={counts.total ?? 0}
                percentage={{ color: "info", text: "" }}
                icon={{ color: "info", component: <PendingActionsIcon /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MiniStatisticsCard
                title={{ text: "Pending" }}
                count={counts.pending ?? 0}
                percentage={{ color: "error", text: "" }}
                icon={{ color: "error", component: <PendingActionsIcon /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <MiniStatisticsCard
                title={{ text: "Resolved" }}
                count={counts.resolve ?? 0}
                percentage={{ color: "success", text: "" }}
                icon={{ color: "success", component: <AssignmentTurnedInIcon /> }}
              />
            </Grid>
          </Grid>
        </SoftBox>
        <Card>
          <SoftBox
            sx={{
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
            }}
          >
            {loading ? <Loading /> : <Table columns={columns} rows={rows} />}
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default HelpPage;
